import React from "react";
import Icon from "../../../../components/Icon";
import Modal from "../../../../components/Modal";

export function DeployToMonitoringModal({
  isOpen,
  onClose,
  assets = [],
  deployFields = {},
  setDeployFields,
  deployConcurrency = 3,
  setDeployConcurrency,
  authorizedBy = "you@company.com",
  onStartDeploy,
  isRedeploy = false,
}) {
  if (!isOpen) return null;

  const targetAssetIds = Object.keys(deployFields);
  const anyStaleSelected = assets.some(
    (a) => targetAssetIds.includes(a.id) && a.status === "stale",
  );

  return (
    <Modal
      title={isRedeploy ? "Redeploy Monitoring Agent" : "Add to Monitoring"}
      onClose={onClose}
      width={600}
    >
      <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
        {isRedeploy && (
          <div
            style={{
              background: "#EFF6FF",
              border: "1px solid #BFDBFE",
              borderRadius: 8,
              padding: "10px 12px",
              fontSize: 12.5,
              color: "#1E40AF",
              display: "flex",
              gap: 8,
              alignItems: "center",
            }}
          >
            <Icon name="info" size={16} color="#2563EB" />
            <span>
              Redeploying will execute the setup script over SSH, update configurations, and restart Osquery & Grafana Alloy services without clearing previous CMDB history.
            </span>
          </div>
        )}
        {anyStaleSelected && (
          <div
            style={{
              background: "#FFF7ED",
              border: "1px solid #FFEDD5",
              borderRadius: 8,
              padding: "12px",
              fontSize: 12.5,
              color: "#C2410C",
              display: "flex",
              gap: 10,
              alignItems: "flex-start",
            }}
          >
            <Icon
              name="alert"
              size={20}
              color="#EA580C"
              style={{ flexShrink: 0, marginTop: 2 }}
            />
            <div>
              <strong style={{ display: "block", marginBottom: 3 }}>
                DHCP IP Reassignment warning!
              </strong>
              One or more checked hosts are marked <strong>Stale</strong>.
              The IP may have been reassigned since the last scan.
              Proceeding with deployment triggers remote SSH script
              executions on these addresses.
            </div>
          </div>
        )}

        <div
          style={{
            maxHeight: 200,
            overflowY: "auto",
            border: "1px solid #E5E7EB",
            borderRadius: 6,
          }}
        >
          <table
            style={{
              width: "100%",
              borderCollapse: "collapse",
              fontSize: 12,
            }}
          >
            <thead>
              <tr
                style={{
                  background: "#F8FAFC",
                  borderBottom: "1px solid #E5E7EB",
                }}
              >
                <th
                  style={{
                    padding: "6px 12px",
                    textAlign: "left",
                    color: "#6B7280",
                  }}
                >
                  Asset
                </th>
                <th
                  style={{
                    padding: "6px 12px",
                    textAlign: "left",
                    color: "#6B7280",
                  }}
                >
                  Target IP
                </th>
                <th
                  style={{
                    padding: "6px 12px",
                    textAlign: "left",
                    color: "#6B7280",
                  }}
                >
                  SSH User
                </th>
                <th
                  style={{
                    padding: "6px 12px",
                    textAlign: "left",
                    color: "#6B7280",
                  }}
                >
                  Kafka Broker
                </th>
              </tr>
            </thead>
            <tbody>
              {targetAssetIds.map((id) => {
                const asset = assets.find((a) => a.id === id);
                if (!asset) return null;
                return (
                  <tr
                    key={id}
                    style={{ borderBottom: "1px solid #E5E7EB" }}
                  >
                    <td style={{ padding: "8px 12px", fontWeight: 600 }}>
                      {asset.name}
                    </td>
                    <td
                      style={{
                        padding: "8px 12px",
                        fontFamily: "monospace",
                      }}
                    >
                      {asset.ip}
                    </td>
                    <td style={{ padding: "6px 12px" }}>
                      <input
                        type="text"
                        value={deployFields[id]?.ssh_user || ""}
                        onChange={(e) =>
                          setDeployFields({
                            ...deployFields,
                            [id]: {
                              ...deployFields[id],
                              ssh_user: e.target.value,
                            },
                          })
                        }
                        style={{
                          padding: "4px 8px",
                          border: "1px solid #D1D5DB",
                          borderRadius: 4,
                          width: "100%",
                          fontSize: 11,
                        }}
                      />
                    </td>
                    <td style={{ padding: "6px 12px" }}>
                      <input
                        type="text"
                        value={deployFields[id]?.kafka_broker || ""}
                        onChange={(e) =>
                          setDeployFields({
                            ...deployFields,
                            [id]: {
                              ...deployFields[id],
                              kafka_broker: e.target.value,
                            },
                          })
                        }
                        style={{
                          padding: "4px 8px",
                          border: "1px solid #D1D5DB",
                          borderRadius: 4,
                          width: "100%",
                          fontSize: 11,
                        }}
                      />
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>

        <div
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            gap: 12,
          }}
        >
          <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
            <label
              style={{ fontSize: 12, fontWeight: 600, color: "#374151" }}
            >
              Concurrency limit
            </label>
            <input
              type="number"
              min="1"
              max="10"
              value={deployConcurrency}
              onChange={(e) =>
                setDeployConcurrency(parseInt(e.target.value, 10) || 1)
              }
              style={{
                padding: "6px 10px",
                border: "1px solid #D1D5DB",
                borderRadius: 6,
              }}
            />
          </div>

          <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
            <label
              style={{ fontSize: 12, fontWeight: 600, color: "#374151" }}
            >
              Authorized by
            </label>
            <input
              value={authorizedBy}
              disabled
              style={{
                padding: "6px 10px",
                border: "1px solid #E5E7EB",
                background: "#F3F4F6",
                borderRadius: 6,
                color: "#6B7280",
              }}
            />
          </div>
        </div>

        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            gap: 10,
            borderTop: "1px solid #F3F4F6",
            paddingTop: 14,
          }}
        >
          <button
            onClick={onClose}
            style={{
              padding: "8px 16px",
              background: "#fff",
              border: "1px solid #D1D5DB",
              borderRadius: 6,
              fontSize: 13,
              cursor: "pointer",
            }}
          >
            Cancel
          </button>
          <button
            onClick={onStartDeploy}
            style={{
              padding: "8px 16px",
              background: "#1D4ED8",
              color: "#fff",
              border: "none",
              borderRadius: 6,
              fontSize: 13,
              fontWeight: 600,
              cursor: "pointer",
            }}
          >
            {isRedeploy ? "Redeploy Agent" : "Deploy Agent"}
          </button>
        </div>
      </div>
    </Modal>
  );
}

export default DeployToMonitoringModal;
